export default __webpack_public_path__ + "static/998-bcd74efb7919ea09f36bb9200c6c4471.gif";